import { AnswerType } from '../../shared/enums/answer.enum';
import { Answer } from './answer.model';

// @dynamic
export type OpenQuestionAnswer = string;

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class OpenAnswer extends Answer {
  public answer: OpenQuestionAnswer | undefined;

  constructor(id: string, type: AnswerType, answer?: OpenQuestionAnswer) {
    super();
    this.id = id;
    this.type = type;
    this.answer = answer;
  }

  public static fromDto(dto: any): OpenAnswer {
    return new OpenAnswer(dto.id, dto.type, dto.answer);
  }
}
